import React from 'react'

export default function ArrowDownSelectIcon(props) {
    //const { style, color } = props;

    return(
        <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill="#2196C0" d="M0.198412 0.198412C0.43891 -0.0420873 0.815252 -0.0639508 1.08045 0.132821L1.15643 0.198412L7 6.04168L12.8436 0.198412C13.0841 -0.0420873 13.4604 -0.0639508 13.7256 0.132821L13.8016 0.198412C14.0421 0.43891 14.064 0.815252 13.8672 1.08045L13.8016 1.15643L7.47901 7.47901C7.23851 7.71951 6.86217 7.74137 6.59697 7.5446L6.52099 7.47901L0.198412 1.15643C-0.0661372 0.891878 -0.0661372 0.46296 0.198412 0.198412Z"/>
        </svg>
    )
}